import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ActiveChatSVG from "../assets/svgs/activeChat.svg";
import ActiveGuideSVG from "../assets/svgs/activeGuide.svg";
import ChatSVG from "../assets/svgs/chat.svg";
import GuidesSVG from "../assets/svgs/guides.svg";

const BottomTabLayout = () => {
  const guideRoute = "/courses";
  const aiRoute = "/ai";
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          height: "calc(100dvh - 65px)",
        }}
        className="scrollbar-hidden"
      >
        <Outlet />
      </div>
      <div
        className="position-fixed w-100 p-2 fixed-bottom left-0 d-flex justify-content-center align-items-center gap-5 border-top border-1 bg-white "
        style={{ zIndex: 1 }}
      >
        <div
          onClick={() => {
            navigate(
              location.pathname.startsWith(guideRoute)
                ? location.pathname
                : guideRoute,
              {
                state: location.state,
              }
            );
          }}
          className="d-flex flex-column justify-content-center align-items-center px-4"
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: location.pathname.startsWith(guideRoute)
              ? "#4286F5"
              : "#000000",
          }}
        >
          <img
            height={30}
            width={20}
            src={
              location.pathname.startsWith(guideRoute)
                ? ActiveGuideSVG
                : GuidesSVG
            }
            alt="Guides"
            style={{ color: "#4286F5" }}
          />
          Guides
        </div>
        <div
          onClick={() => {
            navigate(
              location.pathname.startsWith(aiRoute)
                ? location.pathname
                : aiRoute,
              {
                state: location.state,
              }
            );
          }}
          className="d-flex flex-column justify-content-center align-items-center px-4"
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: location.pathname.startsWith(aiRoute)
              ? "#4286F5"
              : "#000000",
          }}
        >
          <img
            height={30}
            width={20}
            src={
              location.pathname.startsWith(aiRoute) ? ActiveChatSVG : ChatSVG
            }
            alt="Chat"
          />
          AI Bots
        </div>
      </div>
    </>
  );
};

export default BottomTabLayout;
